import React from 'react';
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useSession } from '@supabase/auth-helpers-react';

interface SignUpButtonProps {
  className?: string;
  text?: string;
  variant?: "default" | "outline" | "secondary" | "ghost" | "link" | "destructive" | null | undefined;
}

const SignUpButton = ({ className, text, variant = "default" }: SignUpButtonProps) => {
  const navigate = useNavigate();
  const session = useSession();

  const handleClick = () => {
    if (session) {
      // User is already logged in, redirect to chat
      navigate('/chat');
    } else {
      // User needs to sign up/login
      navigate('/login');
    }
  };

  return (
    <Button 
      onClick={handleClick} 
      className={className || ""}
      variant={variant}
    >
      {text || (session ? "Ir al Chat" : "Crear Cuenta Gratis")}
    </Button>
  );
};

export default SignUpButton;